import axios from 'axios';
import createAuthRefresh from 'axios-auth-refresh';
import { API_CONFIG } from '../config/api';
import { refreshAccessToken, stashLoginReturnPath, TOKEN_KEY } from './authService';

/** Wallet API client: Bearer from storage, token refresh via axios-auth-refresh (queues requests during refresh). */
export const authApi = axios.create({
  baseURL: API_CONFIG.BASE_URL,
  headers: { 'Content-Type': 'application/json' },
});

function setBearerFromStorage(config) {
  const t = localStorage.getItem(TOKEN_KEY);
  const v = t?.trim() ? `Bearer ${t.trim()}` : '';
  if (!config.headers) {
    config.headers = {};
  }
  const h = config.headers;
  if (typeof h.set === 'function') {
    if (v) h.set('Authorization', v);
    else if (typeof h.delete === 'function') h.delete('Authorization');
    else h.set('Authorization', '');
  } else if (v) {
    h.Authorization = v;
  } else {
    delete h.Authorization;
  }
}

authApi.interceptors.request.use((config) => {
  setBearerFromStorage(config);
  return config;
});

createAuthRefresh(
  authApi,
  async (failedRequest) => {
    const { refreshed, authRejected } = await refreshAccessToken();
    if (authRejected && typeof window !== 'undefined') {
      const p = window.location.pathname || '';
      if (p !== '/login' && !p.endsWith('/login')) {
        stashLoginReturnPath(
          `${window.location.pathname}${window.location.search}${window.location.hash}`
        );
        window.location.assign('/login');
      }
    }
    if (!refreshed) {
      return Promise.reject(failedRequest);
    }
    return Promise.resolve();
  },
  {
    statusCodes: [401, 403],
    deduplicateRefresh: true,
    onRetry: (config) => {
      setBearerFromStorage(config);
      return config;
    },
  }
);
